import React from 'react';
import { Link } from 'react-router-dom';
import { Coins } from 'lucide-react';

const PublicNavbar = () => {
  return (
    <nav className="bg-white shadow-lg transition-shadow duration-300">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center space-x-2">
            <Coins className="h-6 w-6 text-blue-600" />
            <span className="text-xl font-semibold">Numismatic Gallery</span>
          </Link>
          <div>
            <Link
              to="/login"
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all duration-200 hover:shadow-md font-medium"
            >
              Sign In
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default PublicNavbar